/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ChevronLeft(props) {
  return (
    <Icon {...props}>
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
    </Icon>
  )
}

ChevronLeft.tags = ['Previous']
ChevronLeft.category = categories.navigation

export default ChevronLeft
